// Widget Scripts

import hauntBackgroundImage from "./widgets/hauntBackgroundImage.js";
import hauntSeoWidget from "./widgets/hauntSeoWidget.js";

$(document).ready(function () {
  if ($(body).hasClass('saffire-haunt-subpage')) {
    hauntBackgroundImage();
    hauntSeoWidget();

    $(globalThis).load(function () {
      $('#goog-gt-tt').remove();
    });
  }
})